import { TWebsiteBuilderRichTextContent, websiteBuilderNormalizeRichTextContent } from "../../richText/websiteBuilderRichTextContent";
import {
  IWebsiteBuilderElementBase,
  IWebsiteBuilderElementDataBase,
  TWebsiteBuilderElement,
} from "./websiteBuilderElement";
import { websiteBuilderGenerateDefaultHideableNodeVisibility } from "../websiteBuilderHideableNode";

interface IWebsiteBuilderHeadingSettings {
  content: TWebsiteBuilderRichTextContent;
}

interface IWebsiteBuilderHeadingData extends IWebsiteBuilderElementDataBase {
  type: "heading";
  settings: IWebsiteBuilderHeadingSettings;
}

export interface IWebsiteBuilderHeading extends IWebsiteBuilderElementBase {
  element: IWebsiteBuilderHeadingData;
}

export function isWebsiteBuilderHeading(node: TWebsiteBuilderElement): node is IWebsiteBuilderHeading {
  return node?.element?.type === "heading";
}

function generateDefaultHeadingSettings(): IWebsiteBuilderHeadingSettings {
  return {
    content: {
      type: "doc",
      attrs: {
        responsiveFontSize: {
          desktop: null,
          tablet: null,
          mobile: null,
        },
      },
      content: [{
        type: "heading",
        attrs: { level: 1 },
        content: [{ type: "text", text: "Heading" }], // TODO: Translation
      }],
    },
  };
}

export function websiteBuilderGenerateDefaultHeading(): IWebsiteBuilderHeading {
  return {
    id: crypto.randomUUID(),
    type: "element",
    element: {
      type: "heading",
      layout: {
        desktop: {
          position: { x: 0, y: 0 },
          dimensions: { width: 150, height: 50 },
        },
        tablet: {
          position: { x: 0, y: 0 },
          dimensions: { width: 150, height: 50 },
        },
        mobile: {
          position: { x: 0, y: 0 },
          dimensions: { width: 150, height: 50 },
        },
      },
      visibility: websiteBuilderGenerateDefaultHideableNodeVisibility(),
      zIndex: 0,
      settings: generateDefaultHeadingSettings(),
    },
  };
}

export function websiteBuilderNormalizeHeadingSettings(partialSettings: Partial<IWebsiteBuilderHeadingSettings>): IWebsiteBuilderHeadingSettings {
  const defaultSettings = generateDefaultHeadingSettings();
  
  if (partialSettings == null) {
    return defaultSettings;
  }

  const normalizedSettings: IWebsiteBuilderHeadingSettings = {
    content: websiteBuilderNormalizeRichTextContent(partialSettings.content),
  };

  return normalizedSettings;
}
